import React from 'react';

import { Container } from './styles';

const CardContainerList: React.FC = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};

export default CardContainerList;
